import { render, staticRenderFns } from "./ChatMessageBubble.vue?vue&type=template&id=e5cc1bda&scoped=true&"
import script from "./ChatMessageBubble.vue?vue&type=script&lang=js&"
export * from "./ChatMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageBubble.vue?vue&type=style&index=0&id=e5cc1bda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cc1bda",
  null
  
)

export default component.exports